var map = {
	"./Home/al.PNG": [
		"./src/images/Home/al.PNG"
	],
	"./Home/ashlogo2.png": [
		"./src/images/Home/ashlogo2.png"
	],
	"./Home/bulgariahospital.jpg": [
		"./src/images/Home/bulgariahospital.jpg"
	],
	"./Home/dan.PNG": [
		"./src/images/Home/dan.PNG"
	],
	"./Home/dannew.PNG": [
		"./src/images/Home/dannew.PNG"
	],
	"./Home/default-image.jpg": [
		"./src/images/Home/default-image.jpg"
	],
	"./Home/email-svgrepo-com.svg": [
		"./src/images/Home/email-svgrepo-com.svg"
	],
	"./Home/facebook.png": [
		"./src/images/Home/facebook.png"
	],
	"./Home/gab.PNG": [
		"./src/images/Home/gab.PNG"
	],
	"./Home/hospital2new.PNG": [
		"./src/images/Home/hospital2new.PNG"
	],
	"./Home/il.PNG": [
		"./src/images/Home/il.PNG"
	],
	"./Home/il.jpeg": [
		"./src/images/Home/il.jpeg"
	],
	"./Home/il.jpg": [
		"./src/images/Home/il.jpg"
	],
	"./Home/instagram.png": [
		"./src/images/Home/instagram.png"
	],
	"./Home/kyivhospital.jpg": [
		"./src/images/Home/kyivhospital.jpg"
	],
	"./Home/linkedin.png": [
		"./src/images/Home/linkedin.png"
	],
	"./Home/lvivhospital.jpg": [
		"./src/images/Home/lvivhospital.jpg"
	],
	"./Home/mainimage.png": [
		"./src/images/Home/mainimage.png"
	],
	"./Home/n.jpg": [
		"./src/images/Home/n.jpg"
	],
	"./Home/sash.PNG": [
		"./src/images/Home/sash.PNG"
	],
	"./Home/vald.PNG": [
		"./src/images/Home/vald.PNG"
	],
	"./Home/wheat_field.png": [
		"./src/images/Home/wheat_field.png"
	],
	"./initiative1/1.jpg": [
		"./src/images/initiative1/1.jpg",
		"src_images_initiative1_1_jpg"
	],
	"./initiative1/2.jpg": [
		"./src/images/initiative1/2.jpg",
		"src_images_initiative1_2_jpg"
	],
	"./initiative1/3.jpg": [
		"./src/images/initiative1/3.jpg",
		"src_images_initiative1_3_jpg"
	],
	"./initiative1/4.jpg": [
		"./src/images/initiative1/4.jpg",
		"src_images_initiative1_4_jpg"
	],
	"./initiative1/5.jpg": [
		"./src/images/initiative1/5.jpg",
		"src_images_initiative1_5_jpg"
	],
	"./initiative1/6.jpg": [
		"./src/images/initiative1/6.jpg",
		"src_images_initiative1_6_jpg"
	],
	"./initiative1/7.jpg": [
		"./src/images/initiative1/7.jpg",
		"src_images_initiative1_7_jpg"
	],
	"./initiative1/8.jpg": [
		"./src/images/initiative1/8.jpg",
		"src_images_initiative1_8_jpg"
	],
	"./initiative1/9.jpg": [
		"./src/images/initiative1/9.jpg",
		"src_images_initiative1_9_jpg"
	],
	"./initiative2/1.jpg": [
		"./src/images/initiative2/1.jpg",
		"src_images_initiative2_1_jpg"
	],
	"./initiative2/10.jpg": [
		"./src/images/initiative2/10.jpg",
		"src_images_initiative2_10_jpg"
	],
	"./initiative2/2.jpg": [
		"./src/images/initiative2/2.jpg",
		"src_images_initiative2_2_jpg"
	],
	"./initiative2/3.jpg": [
		"./src/images/initiative2/3.jpg",
		"src_images_initiative2_3_jpg"
	],
	"./initiative2/4.jpg": [
		"./src/images/initiative2/4.jpg",
		"src_images_initiative2_4_jpg"
	],
	"./initiative2/5.jpg": [
		"./src/images/initiative2/5.jpg",
		"src_images_initiative2_5_jpg"
	],
	"./initiative2/6.jpg": [
		"./src/images/initiative2/6.jpg",
		"src_images_initiative2_6_jpg"
	],
	"./initiative2/7.jpg": [
		"./src/images/initiative2/7.jpg",
		"src_images_initiative2_7_jpg"
	],
	"./initiative2/8.jpg": [
		"./src/images/initiative2/8.jpg",
		"src_images_initiative2_8_jpg"
	],
	"./initiative2/9.jpg": [
		"./src/images/initiative2/9.jpg",
		"src_images_initiative2_9_jpg"
	],
	"./initiative2/hospitallamp.PNG": [
		"./src/images/initiative2/hospitallamp.PNG",
		"src_images_initiative2_hospitallamp_PNG"
	],
	"./initiative2/phototherapylamp.jpeg": [
		"./src/images/initiative2/phototherapylamp.jpeg",
		"src_images_initiative2_phototherapylamp_jpeg"
	],
	"./initiative3/1.jpg": [
		"./src/images/initiative3/1.jpg",
		"src_images_initiative3_1_jpg"
	],
	"./initiative3/2.jpg": [
		"./src/images/initiative3/2.jpg",
		"src_images_initiative3_2_jpg"
	],
	"./initiative3/3.jpg": [
		"./src/images/initiative3/3.jpg",
		"src_images_initiative3_3_jpg"
	],
	"./initiative3/4.jpg": [
		"./src/images/initiative3/4.jpg",
		"src_images_initiative3_4_jpg"
	],
	"./initiative3/5.jpg": [
		"./src/images/initiative3/5.jpg",
		"src_images_initiative3_5_jpg"
	],
	"./initiative3/6.jpg": [
		"./src/images/initiative3/6.jpg",
		"src_images_initiative3_6_jpg"
	],
	"./initiative3/7.jpg": [
		"./src/images/initiative3/7.jpg",
		"src_images_initiative3_7_jpg"
	],
	"./initiative3/8.jpg": [
		"./src/images/initiative3/8.jpg",
		"src_images_initiative3_8_jpg"
	],
	"./initiative4/lviv2pic1.PNG": [
		"./src/images/initiative4/lviv2pic1.PNG",
		"src_images_initiative4_lviv2pic1_PNG"
	],
	"./initiative4/lviv2pic2.PNG": [
		"./src/images/initiative4/lviv2pic2.PNG",
		"src_images_initiative4_lviv2pic2_PNG"
	],
	"./initiative4/lviv2pic3.PNG": [
		"./src/images/initiative4/lviv2pic3.PNG",
		"src_images_initiative4_lviv2pic3_PNG"
	],
	"./initiative4/yuriy1.jpg": [
		"./src/images/initiative4/yuriy1.jpg",
		"src_images_initiative4_yuriy1_jpg"
	],
	"./initiative4/yuriy2.jpg": [
		"./src/images/initiative4/yuriy2.jpg",
		"src_images_initiative4_yuriy2_jpg"
	],
	"./initiative4/yuriy3.jpg": [
		"./src/images/initiative4/yuriy3.jpg",
		"src_images_initiative4_yuriy3_jpg"
	],
	"./initiative5/1.jpeg": [
		"./src/images/initiative5/1.jpeg",
		"src_images_initiative5_1_jpeg"
	],
	"./initiative5/2.jpeg": [
		"./src/images/initiative5/2.jpeg",
		"src_images_initiative5_2_jpeg"
	],
	"./initiative5/3.jpeg": [
		"./src/images/initiative5/3.jpeg",
		"src_images_initiative5_3_jpeg"
	],
	"./initiative6/box1.jpg": [
		"./src/images/initiative6/box1.jpg",
		"src_images_initiative6_box1_jpg"
	],
	"./initiative6/box2.jpg": [
		"./src/images/initiative6/box2.jpg",
		"src_images_initiative6_box2_jpg"
	],
	"./initiative6/box3.jpg": [
		"./src/images/initiative6/box3.jpg",
		"src_images_initiative6_box3_jpg"
	],
	"./initiative6/box4.jpg": [
		"./src/images/initiative6/box4.jpg",
		"src_images_initiative6_box4_jpg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/images lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;